import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    PASSWORD_RESET_FAIL,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_CONFIRM_FAIL,
    PASSWORD_RESET_CONFIRM_SUCCESS,
    SIGNUP_SUCCESS,
    SIGNUP_FAIL,
    ACTIVATION_SUCCESS,
    ACTIVATION_FAIL,
    GOOGLE_AUTH_SUCCESS,
    GOOGLE_AUTH_FAIL,
    LOGOUT
} from '../actions/types';
import {
    clearAuthTokens,
    getAccessToken,
    storeAuthTokens
} from '../utils/authToken';

const initialState = {
    access: getAccessToken(),
    refresh: null,
    isAuthenticated: null,
    user: null
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case AUTHENTICATED_SUCCESS:
            return {
                ...state,
                isAuthenticated: true
            };

        case LOGIN_SUCCESS:
        case GOOGLE_AUTH_SUCCESS:
            storeAuthTokens(payload);
            return {
                ...state,
                isAuthenticated: true,
                access: payload.access,
                refresh: null
            };

        case SIGNUP_SUCCESS:
            return {
                ...state,
                isAuthenticated: false
            };

        case USER_LOADED_SUCCESS:
            return {
                ...state,
                user: payload
            };

        case AUTHENTICATED_FAIL:
            return {
                ...state,
                isAuthenticated: false
            };

        case LOGOUT:
        case GOOGLE_AUTH_FAIL:
        case LOGIN_FAIL:
        case SIGNUP_FAIL:
            clearAuthTokens();
            return {
                ...state,
                access: null,
                refresh: null,
                isAuthenticated: false,
                user: null
            };

        case USER_LOADED_FAIL:
            return {
                ...state,
                user: null
            };

        case PASSWORD_RESET_FAIL:
        case PASSWORD_RESET_SUCCESS:
        case PASSWORD_RESET_CONFIRM_FAIL:
        case PASSWORD_RESET_CONFIRM_SUCCESS:
        case ACTIVATION_SUCCESS:
        case ACTIVATION_FAIL:
            return {
                ...state
            };

        default:
            return state;
    }
}
